module.exports = __webpack_public_path__ + "static/img/6.46da11e1.png";